// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__14kEu","errorLogs":"styles_errorLogs__T-jdZ"};